import type { User } from '@ztechapps/common.contract'

/**
 * The customer as a customer select's value — the customer itself, with its company reshaped to a select option
 * (`value` and `label` beside `name`).
 */
export const toCustomerSelectValue = (customer?: User) => ({
  ...customer,
  company: { value: customer?.company?._id, name: customer?.company?.name, label: customer?.company?.name },
})
